import { BASE_API_URL } from '@/constant/api'
import { AppResp } from '@/types/api'
import {
  ActivityDetailPageReq,
  ActivityDetailPageRes,
  ActivityListResp,
  ActivityMetricReq,
  ActivityMetricResp,
  DailyCampaignDrawReq,
  DailyCampaignDrawResult,
  DailyCampaignStatus,
  DailyCampaignStatusReq,
  EggHuntClaimReq,
  EggHuntClaimResponse,
  EggHuntStatusReq,
  EggHuntStatusResponse,
  MayBallActivityChatTarget,
  MayBallCharacterLeaderboardReq,
  MayBallCharacterLeaderboardRes,
  MayBallRecentlyChattedSingleReq,
  MayBallVoterLeaderboardRes,
} from '@/types/activity'
import { axiosAuth, axiosPublic } from '@/utils/axios'
import { RemoteSplashPVCurrentResponse } from '@/constant/mayBallSplashPV'

// 获取活动 metric（Heat Level）+ 礼物库存
export const getActivityMetricUrl = `${BASE_API_URL}/activity/metric/get`
export const getActivityMetric = async (req: ActivityMetricReq) => {
  const res = await axiosAuth.post<AppResp<ActivityMetricResp>>(
    getActivityMetricUrl,
    req
  )
  return res.data.data
}

// 从 metric 返回里取某 gift_code 的库存数量
export const getGiftQuantityFromMetric = (
  metric: ActivityMetricResp | null | undefined,
  giftCode: string
): number => {
  const item = metric?.gift_inventory?.find((g) => g.gift_code === giftCode)
  const quantity = Number(item?.quantity ?? 0)
  return Number.isFinite(quantity) ? quantity : 0
}

export const getActivityDetailPageUrl = `${BASE_API_URL}/activity/activity_info`
export const getActivityDetailPage = async (req: ActivityDetailPageReq) => {
  const res = await axiosPublic.post<AppResp<ActivityDetailPageRes>>(
    getActivityDetailPageUrl,
    req
  )

  if (!res.data.data) {
    throw new Error('No activity detail data')
  }

  return res.data.data
}

// 获取活动列表(多语言)
export const getActivityListUrl = `${BASE_API_URL}/activity/list_multilang`
export const getActivityList = async () => {
  const res = await axiosPublic.post<AppResp<ActivityListResp>>(
    getActivityListUrl,
    {}
  )

  if (!res.data.data) {
    throw new Error('No activity list data')
  }
  return res.data.data
}

export const getSplashPVCurrentUrl = `${BASE_API_URL}/splash-pv/current`
export const getMayBallSplashPVCurrent = async () => {
  const res = await axiosPublic.post<AppResp<RemoteSplashPVCurrentResponse>>(
    getSplashPVCurrentUrl,
    { scene: 'may_ball' }
  )

  return res.data.data?.config ?? null
}

export const getDailyCampaignStatusUrl = `${BASE_API_URL}/user/campaign/daily/status`
export const getDailyCampaignStatus = async (req: DailyCampaignStatusReq) => {
  const res = await axiosAuth.post<AppResp<DailyCampaignStatus>>(
    getDailyCampaignStatusUrl,
    req
  )

  if (!res.data.data) {
    throw new Error('No daily campaign status data')
  }

  return res.data.data
}

export const drawDailyCampaignUrl = `${BASE_API_URL}/user/campaign/daily/draw`
export const drawDailyCampaign = async (req: DailyCampaignDrawReq) => {
  const res = await axiosAuth.post<AppResp<DailyCampaignDrawResult>>(
    drawDailyCampaignUrl,
    req
  )

  if (!res.data.data) {
    throw new Error('No daily campaign draw data')
  }

  return res.data.data
}

export const getEggHuntStatusUrl = `${BASE_API_URL}/user/campaign/collect/status`
export const getEggHuntStatus = async (req: EggHuntStatusReq) => {
  const res = await axiosAuth.post<AppResp<EggHuntStatusResponse>>(
    getEggHuntStatusUrl,
    req
  )

  if (!res.data.data) {
    throw new Error('No egg hunt status data')
  }

  return res.data.data
}

export const claimEggHuntRewardUrl = `${BASE_API_URL}/user/campaign/collect/claim`
export const claimEggHuntReward = async (req: EggHuntClaimReq) => {
  const res = await axiosAuth.post<AppResp<EggHuntClaimResponse>>(
    claimEggHuntRewardUrl,
    req
  )

  if (!res.data.data) {
    throw new Error('No egg hunt claim data')
  }

  return res.data.data
}

export const getMayBallRecentlyChattedSingleUrl = `${BASE_API_URL}/user/character/recently_chatted_single`
export const getMayBallRecentlyChattedSingle = async (
  req: MayBallRecentlyChattedSingleReq = { limit: 1 }
) => {
  const res = await axiosAuth.post<AppResp<MayBallActivityChatTarget | null>>(
    getMayBallRecentlyChattedSingleUrl,
    req
  )

  return res.data.data ?? null
}

export const getMayBallTopIntimacyUrl = `${BASE_API_URL}/user/character/top_intimacy`
export const getMayBallTopIntimacy = async () => {
  const res = await axiosAuth.post<AppResp<MayBallActivityChatTarget | null>>(
    getMayBallTopIntimacyUrl
  )

  return res.data.data ?? null
}

export const getMayBallCharacterLeaderboardUrl = `${BASE_API_URL}/activity/one_last_dance/leaderboard/character`
export const getMayBallCharacterLeaderboard = async (
  req: MayBallCharacterLeaderboardReq
) => {
  const res = await axiosPublic.post<AppResp<MayBallCharacterLeaderboardRes>>(
    getMayBallCharacterLeaderboardUrl,
    req
  )

  if (!res.data.data) {
    throw new Error('No May Ball character leaderboard data')
  }

  return res.data.data
}

export const getMayBallVoterLeaderboardUrl = `${BASE_API_URL}/activity/one_last_dance/leaderboard/voter`
export const getMayBallVoterLeaderboard = async () => {
  const res = await axiosPublic.post<AppResp<MayBallVoterLeaderboardRes>>(
    getMayBallVoterLeaderboardUrl,
    {}
  )

  if (!res.data.data) {
    throw new Error('No May Ball voter leaderboard data')
  }

  return res.data.data
}
